import { baseApi } from './baseApi';

export const documentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get documents list
    getDocuments: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `document/list?${queryString}` : 'document/list',
        method: 'GET',
      }),
      providesTags: ['Documents'],
    }),

    // Get single document
    getDocument: builder.query({
      query: (documentId) => ({
        url: `document/get/${documentId}`,
        method: 'GET',
      }),
      providesTags: (result, error, documentId) => [{ type: 'Document', id: documentId }],
    }),

    // Create document
    createDocument: builder.mutation({
      query: (body) => ({
        url: 'document/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Documents'],
    }),

    // Update document
    editDocument: builder.mutation({
      query: (body) => ({
        url: 'document/update',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'Document', id: body?.id },
        'Documents',
      ],
    }),

    // Delete document
    deleteDocument: builder.mutation({
      query: (documentId) => ({
        url: `document/delete/${documentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Documents'],
    }),
  }),
});

export const {
  useGetDocumentsQuery,
  useGetDocumentQuery,
  useCreateDocumentMutation,
  useEditDocumentMutation,
  useDeleteDocumentMutation,
} = documentsApi;